import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const Footer = styled(Typography)({
  color: '#646464',
  fontSize: '14px',
  fontFamily: 'Open Sans !important',
  fontWeight: 400,
  wordWrap: 'break-word',
});

export default Footer;
